import { useMemo } from 'react'
import { Button, Result } from 'antd'
import { API_BASE_URL } from '../api/client'

const ApiDocs = () => {
  const docsUrl = useMemo(() => {
    const base = API_BASE_URL.replace(/\/api\/v1\/?$/, '')
    return `${base}/docs`
  }, [])

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', padding: 24 }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <Result
          status="info"
          title="API 在线文档"
          subTitle="文档访问受 IP 白名单控制，如无法访问请联系管理员添加 IP。"
          extra={[
            <Button type="primary" key="open" href={docsUrl} target="_blank">
              打开文档
            </Button>,
          ]}
        />
        <div style={{ borderRadius: 8, overflow: 'hidden', background: '#fff' }}>
          <iframe
            title="api-docs"
            src={docsUrl}
            style={{ width: '100%', height: '80vh', border: 'none' }}
          />
        </div>
      </div>
    </div>
  )
}

export default ApiDocs
